import * as React from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { getEnvironment, getReactEnvironment } from '../Shared/Environemt'

const Layout = (props) => (
    <>
        {
            props.syncOverride === true && <div className='sync-disabled-banner'>
                SYNC JOB IS CURRENTLY DISABLED <button className='k-button-solid-primary k-button-lg' onClick={() => props.toggleOverride()}>Re-Enable</button>
            </div>
        }
        <header className={"application " + getEnvironment() + " " + getReactEnvironment() }>
            <div className="brand-header">
                <p className="application-title">{props.applicationName}</p>
                <span className="logo"  aria-hidden="true" title="The Ohio State University Medical Center logo"></span>
                <span className="visually-hidden">The Ohio State University Medical Center logo</span>
            </div>
        </header>
        <NavMenu />
        <main>
            <section id="main-content" className="wrapper">
                <article>
                    <Container>
                        {props.children}
                    </Container>
                </article>
            </section>
        </main>
        <footer className="application">
            <p className="contact">
                <a target="_blank" href="https://osumc.sharepoint.com/sites/ITSelfService">IT Service Desk</a> <a href="tel:6142934357">614-293-HELP(4357)</a>&nbsp;&nbsp;&nbsp;
                <a href="https://apps.osumc.edu/Enterprise/feedback/home/Index" target="_blank">Report a problem</a>
            </p>
            <span className="logo" title="The Ohio State University Medical Center logo"></span>
            <p className="set">This application is maintained and supported by: Software Engineering Team - Enterprise</p>
            <p className="set">If you have a disability and experience difficulty accessing this content, please submit an <a href="https://osumc.service-now.com/sp?id=sc_cat_item&sys_id=6239f9861b348954ef26ca2b234bcbed">eService accessibility request</a> for assistance.</p>
        </footer>
    </>
);

export default Layout;